import { PureComponent } from 'react';

import { type IFileProps } from './File'
import { FileInfoStyled } from './styles/FileInfoStyled'
import { SubText } from '../../elements/Text'
import { filesize } from '../../utils/filters'

export class FileInfo extends PureComponent<IFileProps> {
  static defaultProps = {}

  render() {
    const { file, name, error } = this.props.data

    return (
      <FileInfoStyled error={!!error}>
        <div>
          {file ? (
            <a href={file} target='_blank' rel='noreferrer'>
              <SubText className='filename' textEllipsis>
                {name || file}
              </SubText>
            </a>
          ) : (
            <SubText className='filename' textEllipsis>
              {name}
            </SubText>
          )}
        </div>
        <div>
          <SubText className='filemeta'>{this.buildFileMeta()}</SubText>
        </div>
      </FileInfoStyled>
    )
  }

  private buildFileMeta() {
    const { length, mimetype, error } = this.props.data

    const meta = []

    if (error) {
      meta.push('Error')

      if (typeof error === 'string') {
        meta.push(error)
      }
    }
    if (length) meta.push(filesize(length))
    if (mimetype) meta.push(mimetype)

    return meta.join(' - ')
  }
}
